import { HttpContextToken } from '@angular/common/http';

export interface DisableErrorCode {
  codes: number | number[] | 'ALL' | undefined;
}

export const DISABLE_HTTP_GLOBAL_ERROR_TO_BE_HANDLED = new HttpContextToken<DisableErrorCode>(
  () => ({
    codes: undefined,
  }),
);
